
import SvgIcon from "Theme/SvgIcon"
import { ReactComponent as LatestactvityIcon } from "../fontello/icons/svg/ic_latestactvity.svg"


const Latestactvity = ({ ...props }) => (
  <SvgIcon
    component={LatestactvityIcon}
    viewBox="0 0 1000 1000"
    {...props}
  />
)


export default Latestactvity
